<template>
  <main id="content">
    <LocationMap />
  </main>
</template>

<script setup lang="ts">
definePageMeta({ layout: false });

useHead({
  title: 'Find a Location',
  meta: [
    {
      name: 'description',
      content: 'Search for community locations near you.'
    }
  ]
});
</script>
